import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { AuthActionButton } from "../components/AntCostomComponents/Buttons";
import LogoAndText from "../components/LogoAndText";
import {
    Form,
    LeftContainer,
    RightContainer,
    SideWrapper,
    TextContainer,
} from "../components/SideWrapper/SideWrapper.styles";
import { forgetPassword } from "../utils/api-lists/login.api";

const ForgetPasswordPage = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const { t } = useTranslation("common");

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
    await forgetPassword(email.trim());
  } catch (err) {
    // Ignore errors so we don't reveal whether email exists or not
  }
  setSent(true);
  };

  if (sent) {
    return (
      <SideWrapper>
        <LeftContainer>
          <LogoAndText />
        </LeftContainer>
        <RightContainer>
          <h2 style={{ marginBottom: "20px" }}>{t("forget_password")}</h2>
          <p>{t("reset_link_sent_hint")}</p>
          <p style={{ fontWeight: "bold" }}>{email}</p>
        </RightContainer>
      </SideWrapper>
    );
  }

  return (
    <SideWrapper>
      <LeftContainer>
        <LogoAndText />
      </LeftContainer>
      <RightContainer>
        <h2>{t("forget_password")}</h2>
        <TextContainer>
          <h3>{t("enter_email")}</h3>
        </TextContainer>
        <Form
          onSubmit={handleSubmit}
          style={{ marginTop: "40px", maxWidth: "400px" }}
        >
          <label>{t("email")}</label>
          <input
            placeholder={t("email")}
            name="email"
            type="email"
            onChange={(e) => setEmail(e.target.value)}
          />

          <AuthActionButton text={t("next")} htmlType="submit" />
          <br />
          <p>
            {t("back_to_signing")}{" "}
            <span onClick={() => navigate("/login")}>{t("sign_in")}</span>
          </p>
        </Form>
      </RightContainer>
    </SideWrapper>
  );
};

export default ForgetPasswordPage;
